import React from "react";
import { useIntl } from "react-intl";
import { TextArea } from "semantic-ui-react";

type Props = {
  comment: string;
  setComment: (e: any) => void;
};

const CommentForm: React.FC<Props> = ({ comment, setComment }) => {
  const intl = useIntl();

  return (
    <>
      <TextArea
        placeholder={intl.formatMessage({ id: "site.commentForm.placeholder" })}
        value={comment}
        onChange={(e: any) => setComment(e.target.value)}
      />
    </>
  );
};

export default CommentForm;
